import React from 'react';
import TableFloatingReport from './table/tableFloatingReport';
import {Dimmer, Loader} from 'semantic-ui-react';
import SearchFloatingInventory from './searchFloatingInventory';
import './styles.scss';
import {useFloatingReport} from './useFloatingReport';
import HeaderReport from '../commons/headerReport';
import {tableHeaderWithProps} from './table/columns';

const FloatingReport = () => {
  const {
    'actions': {
      setResetAllFilters,
      useTableValues,
    },
    'data': {
      dataTable,
      filteredRows,
      loading,
      isUserTde,
      dealerId,
    },
  } = useFloatingReport();
  return <>
    <Dimmer
      inverted
      active={loading}
      style={{
        'width': '100%',
        'height': '100%',
        'position': 'fixed',
        'top': '0',
        'background': 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Loader size='large'/>
    </Dimmer>
    <HeaderReport
      filteredData={filteredRows}
      titles={tableHeaderWithProps(isUserTde, dealerId)}
      isUserTde={isUserTde}
      dealerId={dealerId}

    />
    <SearchFloatingInventory
      setResetAllFilters={setResetAllFilters}
    />
    <TableFloatingReport
      useTableValues={useTableValues}
      dataLength={dataTable?.length}
    />
  </>;
};

export default FloatingReport;
